import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortAscending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlockSortAscending"><Path d="M11 21H3V13H11V21ZM22.7803 10.4795L21.7197 11.54L18.75 8.57031V18H17.25V8.57031L14.2803 11.54L13.2197 10.4795L18 5.69922L22.7803 10.4795ZM11 11H3V3H11V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlockSortAscending;
